import React, { lazy } from 'react';

import { DashboardLayout } from '../../components/atoms';
import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ReactComponent as CompanyIcon } from '../../assets/svg/company.svg';
import { ReactComponent as MailIcon } from '../../assets/svg/mailroom.svg';
import { ReactComponent as SecretaryIcon } from '../../assets/svg/company-secretary.svg';
import { ReactComponent as RequestsIcon } from '../../assets/svg/requests.svg';
import { ReactComponent as PreferencesIcon } from '../../assets/svg/preferences.svg';
import { FiCreditCard, FiSettings, FiUsers, FiMessageSquare, FiFileText, FiCalendar, FiHelpCircle, FiHome, FiUser, FiPlus, FiRefreshCw } from 'react-icons/fi';
import { useSelector } from 'react-redux';
import { styleGuideSelector } from '../../store/globalSlice/styleSlice';

const DashboardAsideBar = lazy(() => import('../../components/DashboardTemplate/DashboardAsideBar'));
const DashboardHeader = lazy(() => import('../../components/DashboardTemplate/DashboardHeader'));

const DashboardAgent: React.FC = () => {
  const { t } = useTranslation();
  const { colors } = useSelector(styleGuideSelector);
  const items = {
    initial: [],
    company: [
      {
        label: t('others.otheNewCompany'),
        icon: <FiPlus color={colors.primary} size={24} />,
        href: '/dashboard'
      },
      {
        label: t('others.otheTransferredCompanies'),
        icon: <FiHome color={colors.primary} size={24} />,
        href: '/dashboard/transferred-companies'
      },
      {
        label: t('labels.lblContactUs'),
        icon: <FiMessageSquare color={colors.primary} size={24} />,
        href: '/dashboard/chat'
      },
      {
        label: t('others.othServiceConfig'),
        icon: <FiUsers color={colors.primary} size={24} />,
        href: '/dashboard',
        showCommingSoon: true,
        isVisible: false
      },
      // {
      //   label: 'Status Documents',
      //   icon: <FiFileText color={colors.primary} size={24} />,
      //   href: '/dashboard/documents-status',
      // },
      {
        label: t('others.othScheduleSpecialist'),
        icon: <FiCalendar color="currentColor" size={24} />,
        href: '/dashboard/specialists',
        lookDisabled: true
      },
      {
        label: t('labels.lblRequestsBar'),
        icon: <RequestsIcon style={{ fill: colors.primary }} />,
        href: '/dashboard/request'
      },
      {
        label: t('labels.lblPaymentStatus'),
        icon: <FiCreditCard color={colors.primary} size={24} />,
        href: '/dashboard/payment-status'
      }
    ],
    config: [
      {
        label: t('labels.lblPrefereces'),
        icon: <FiUser color={colors.primary} size={24} />,
        href: '/dashboard/preferences'
      },
      {
        label: t('labels.lblEnvironmentSetup'),
        icon: <FiSettings color={colors.primary} size={24} />,
        href: '/dashboard/environment-setup'
      }
    ]
  };
  return (
    <DashboardLayout headerComponent={<DashboardHeader />} sidebarComponent={<DashboardAsideBar items={items} />}>
      <Outlet />
    </DashboardLayout>
  );
};

export { DashboardAgent };
